/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const {HeroFlex, HeroGrid, Content, Row, Column, Markup, TwoImagesParallax, Jumbotron, HorizontalParallaxText, AccordionFaqWrapper, AccordionFaqItem, CardDeck, Card} = Object.assign({}, _provideComponents(), props.components);
  if (!AccordionFaqItem) _missingMdxReference("AccordionFaqItem", true);
  if (!AccordionFaqWrapper) _missingMdxReference("AccordionFaqWrapper", true);
  if (!Card) _missingMdxReference("Card", true);
  if (!CardDeck) _missingMdxReference("CardDeck", true);
  if (!Column) _missingMdxReference("Column", true);
  if (!Content) _missingMdxReference("Content", true);
  if (!HeroFlex) _missingMdxReference("HeroFlex", true);
  if (!HeroGrid) _missingMdxReference("HeroGrid", true);
  if (!HorizontalParallaxText) _missingMdxReference("HorizontalParallaxText", true);
  if (!Jumbotron) _missingMdxReference("Jumbotron", true);
  if (!Markup) _missingMdxReference("Markup", true);
  if (!Row) _missingMdxReference("Row", true);
  if (!TwoImagesParallax) _missingMdxReference("TwoImagesParallax", true);
  return React.createElement(React.Fragment, null, React.createElement(HeroFlex, null, React.createElement(HeroGrid, {
    mainSrc: "/hero/grid/hero-grid-business-essential-checking.jpg",
    secondarySrc: "/hero/grid/accents/grid-accent-dark-sycamore.jpg",
    gradientClass: "bg-redGradient",
    heroSubTitle: "Simple, convenient and low-cost",
    heroTitle: "Business Essential Checking",
    heroBody: "<p>Looking for a basic business checking account for your small business? Look no further than business essential checking from Mountain America.</p>",
    heroFooter: "<div class=\"d-flex align-items-center flex-wrap\"><a href=\"https://schedule.macu.com/s/business-account\" class=\"btn btn-light\">Schedule appointment</a></div>",
    mainAlt: "sunset over mountains",
    secondaryAlt: "Dark tree bark background"
  })), "\n", React.createElement(Content, {
    noBorder: true,
    className: "pt-lg-6 pt-xxl-8 pb-sm-0"
  }, React.createElement(Row, null, React.createElement(Column, {
    className: "p-4 px-sm-5 px-xl-6 py-5"
  }, React.createElement(Markup, {
    html: "<div><h2 id=\"what-is-a-business-essential-checking-account\">What is a business essential checking account?</h2><p>Business essential checking is the perfect account for small or medium-sized businesses. It equips you to conveniently manage your company&#x27;s finances, specifically if your business has less than 300 checks written and deposited and less than $10,000 per month in cash transactions.</p><h5 id=\"benefits-of-business-essential-checking\">Benefits of business essential checking</h5><ul><li>The $5 monthly maintenance charge is waived when you sign up for eStatements</li><li>No charge for checks deposited and cleared¹</li><li>No charge for cash and coin handling¹</li><li>Free online business banking</li><li>Free online bill pay²</li></ul></div>"
  })), React.createElement(Column, {
    className: "px-xl-6 px-lg-5 px-0 py-lg-6 py-0"
  }, React.createElement(TwoImagesParallax, {
    foregroundImage: "/body/body-foreground-hiking-woman.jpg",
    foregroundWidth: 100,
    backgroundImage: "/body/body-peeling-bark.jpg",
    backgroundWidth: 35,
    backgroundPosition: "top-right",
    offset: 4,
    foregroundAlt: "woman standing on a mountain with lake scenery",
    backgroundAlt: "Bark peeling off a tree."
  })))), "\n", React.createElement(Jumbotron, {
    className: "px-4 px-xl-5 px-xxl-0"
  }, React.createElement(Content, {
    noBorder: true,
    className: "bg-pebbleGradient px-xl-6 px-lg-5 px-4 py-5 my-6 text-white rounded"
  }, React.createElement(Row, null, React.createElement(Column, {
    className: "text-center col-lg-8 mx-auto "
  }, React.createElement(Markup, {
    html: "<h2>Open a business essential checking account today</h2><p>Mountain America is here to help your business succeed, whether in Utah, Idaho, Arizona, Nevada, Montana or beyond. To meet with an experienced business advisor, schedule an appointment online, call <a class=\"text-white\" href=\"tel:1-888-845-1850\">1‑888‑845‑1850</a> or visit your nearest <a class=\"text-white\" href=\"/branch-locations\">Mountain America branch</a>.</p><a href=\"https://schedule.macu.com/s/business-account\" class=\"btn btn-light py-2\">Schedule appointment</a>",
    cssStyle: ".bg-mutedPlumGradient {background: linear-gradient(94deg, rgba(97, 81, 78, 0.95) 2.58%, rgba(203, 177, 206, 0.95) 102.6%),	url(\'https://www.macu.com/media/textures/noise.gif\');}.bg-grayGradient {background: linear-gradient(0deg, rgba(138, 124, 119, 0.95) -11.33%, rgba(197, 190, 186, 0.95) 90.61%),	url(\'https://www.macu.com/media/textures/noise.gif\');}.bg-copperGradient {background: linear-gradient(111deg, rgba(169, 84, 37, 0.95) 27.18%, rgba(207, 133, 118, 0.95) 99.46%),	url(\'https://www.macu.com/media/textures/noise.gif\');} .bg-opacity-10 {	background-color:rgba(256, 256, 256, 0.1);}"
  }))))), "\n", React.createElement(Jumbotron, {
    className: "bg-gray-100 pt-xxl-8 pt-6"
  }, React.createElement(HorizontalParallaxText, {
    text: "Business Essential Checking FAQs"
  })), "\n", React.createElement(Jumbotron, {
    className: "py-xxl-8 py-6 px-xl-6 px-lg-5 px-4 bg-gray-100"
  }, React.createElement(Content, {
    noBorder: true
  }, React.createElement(AccordionFaqWrapper, {
    enableSchema: true
  }, React.createElement(AccordionFaqItem, {
    question: "What is a small business checking account?",
    answer: "<p>A small business checking account is similar to a personal checking account, but is specifically made to help businesses better manage their activity and growth. A small business checking account helps simplify taxes, promotes credibility and offers protection against personal liability.</p>"
  }), React.createElement(AccordionFaqItem, {
    question: "Can I use a personal bank account for my small business?",
    answer: "<p>If your small business is a separate legal entity, you are required to separate your business and personal funds and open a business account.</p>"
  }), React.createElement(AccordionFaqItem, {
    question: "What kind of bank account do I need for a small business?",
    answer: "<div><p>Typical bank accounts for a small business include:</p><ul><li>Checking account</li><li>Savings account</li><li>Merchant services account</li><li>Credit card account</li></ul></div>"
  }), React.createElement(AccordionFaqItem, {
    question: "What items are required to open a business essential checking account?",
    answer: "<div><p>Please bring the following items to open your account:</p><ul><li>Company EIN</li><li>State registration</li><li><a href=\"/media/pdf/Beneficial-Ownership-form-5434.pdf\">Beneficial owner info</a> for all 25% or greater owners</li><li>Personal ID and SSN</li><li>Minimum opening deposit of $1 for savings and $100 for checking</li></ul><p>For all entities other than sole proprietors, organizational documents are required. This may be satisfied with a printout from the state website listing the business principals. Otherwise, we accept articles of organization for LLCs, articles of incorporation for corporations (including nonprofit corporations), and a partnership agreement for general and limited partnerships.</p></div>"
  })))), "\n", React.createElement(Content, {
    noBorder: true
  }, React.createElement(Row, null, React.createElement(CardDeck, {
    cardType: "SimpleTextPhoto",
    className: "p-4 pt-6",
    cardClassName: "mb-3",
    desktopColumns: 3,
    tabletColumns: 2,
    mobileColumns: 1
  }, React.createElement(Card, {
    cardImage: "/media/thumbnails/cards/simple/card-business-credit-cards-768x336.jpg",
    cardTitle: "Business credit cards",
    cardBody: "<p>Choose between our Business Low Rate and Business Rewards credit cards.</p>",
    cardFooter: "<a class=\"btn btn-outline-dark\" href=\"/business/loans/visa-cards\">Get more details</a>",
    backgroundColor: "bg-pebble",
    cardAlt: "Person using credit card on computer"
  }), React.createElement(Card, {
    cardImage: "/media/thumbnails/cards/simple/card-small-business-loans-768x336.jpg",
    cardTitle: "Business loans",
    cardBody: "<p>Get personalized, low-rate financing to help your business succeed.</p>",
    cardFooter: "<a class=\"btn btn-outline-dark\" href=\"/business/loans\">Explore loans</a>",
    backgroundColor: "bg-pebble",
    cardAlt: "Woman rock climbing"
  }), React.createElement(Card, {
    cardImage: "/media/thumbnails/cards/simple/card-business-sweep.jpg",
    cardTitle: "Business sweep accounts",
    cardBody: "<p>Automatically move excess funds from your business checking into a dividend-bearing account.</p>",
    cardFooter: "<a class=\"btn btn-outline-dark\" href=\"/business/checking/business-sweep\">Learn more</a>",
    backgroundColor: "bg-pebble",
    cardAlt: "businesswoman on her phone"
  })))), "\n", React.createElement(Content, {
    noBorder: true
  }, React.createElement(Row, null, React.createElement(Column, {
    className: "px-xl-6 px-lg-5 px-4 pt-6"
  }, React.createElement(Markup, {
    className: "macu-disclosure",
    html: "<ol start=\"1\"><li>If combined monthly items deposited and cleared exceed 300 or aggregate monthly cash/coin exceeds $10,000 per month for two consecutive months, the account will be converted to a business growth checking account.</li><li>No charge for the first 10 bills per month, 60¢ per bill above 10.</li></ol>"
  })))));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
